module.exports = __webpack_public_path__ + "img/Blog Admin 4.7b3e6e09.jpg";